<!-- Modale de filtres -->
@if (layoutMode !== 'desktop') {
  <ng-casto-composition-filters
    [isOpen]="isFiltersModalOpen"
    (filtersApplied)="onFiltersApplied($event)"
    (filterSkipped)="onFiltersSkipped()"
    (closed)="onFiltersModalClosed()">
  </ng-casto-composition-filters>
}

<div class="composition-page" [class.embedded]="embedded" [class.desktop]="layoutMode === 'desktop'">
  <!-- Loading state -->
  @if (isLoading) {
    <div class="loading-container">
      <div class="spinner"></div>
      <p>Chargement des compositions...</p>
    </div>
  }

  <!-- Error state -->
  @if (error && !isLoading) {
    <div class="error-container">
      <i class="fas fa-exclamation-triangle"></i>
      <p>{{ error }}</p>
    </div>
  }

  <!-- Content -->
  @if (!isLoading && !error) {
    <div class="composition-content">
      <!-- Image de la gamme avec effet parallax -->
      <div class="range-image-container">
        @if (range?.imageUrl) {
          <div #rangeImage class="range-image" [style.transform]="'translateY(-' + imageScrollPosition + 'px)'">
            <img [src]="range.imageUrl" [alt]="range.name" />
          </div>
        }

        <!-- Bouton Filtrer -->
        <button class="filter-button" (click)="openFiltersModal()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="4" y1="6" x2="20" y2="6"></line>
            <line x1="4" y1="12" x2="20" y2="12"></line>
            <line x1="4" y1="18" x2="20" y2="18"></line>
            <circle cx="8" cy="6" r="2" fill="currentColor"></circle>
            <circle cx="16" cy="12" r="2" fill="currentColor"></circle>
            <circle cx="10" cy="18" r="2" fill="currentColor"></circle>
          </svg>
          Filtrer
        </button>
      </div>

      @if (layoutMode === 'desktop') {
        <div class="desktop-filters">
          <ng-casto-composition-filters
            displayMode="inline"
            [initialFilters]="appliedFilters || undefined"
            (filtersApplied)="onFiltersApplied($event)"
            (filterSkipped)="onFiltersSkipped()">
          </ng-casto-composition-filters>
        </div>
      }

      <div class="results-area">
        <!-- Header fixe -->
        <h1 class="range-title">
          Collection <span class="blue">{{ range?.name || 'Chargement...' }}</span>
        </h1>

        <!-- Contenu avec fond blanc -->
        <div class="content-wrapper">
          <!-- Nombre de compositions -->
          <p class="composition-count">{{ compositions.length }} composition{{ compositions.length > 1 ? 's' : '' }}</p>

          <!-- Grid de compositions -->
          <div class="compositions-grid">
            @for (composition of compositions; track composition.id) {
              <div class="composition-card" (click)="onCompositionClick(composition)">
                <!-- Schéma de la composition -->
                <div class="composition-schema">
                  @if (composition.thumbnailUrl) {
                    <img [castoLazyImage]="composition.thumbnailUrl" [alt]="composition.name" class="schema-image" />
                  } @else {
                    <div class="schema-placeholder">
                      <!-- Placeholder simple avec des rectangles -->
                      <svg viewBox="0 0 100 100" class="placeholder-svg">
                        <rect x="10" y="20" width="80" height="30" fill="none" stroke="#ccc" stroke-width="2" />
                        <rect x="10" y="55" width="80" height="30" fill="none" stroke="#ccc" stroke-width="2" />
                      </svg>
                    </div>
                  }
                </div>

                <!-- Nom de la composition -->
                <p class="composition-name">{{ composition.name }}</p>
              </div>
            }
          </div>

          <!-- Empty state -->
          @if (compositions.length === 0) {
            <div class="empty-state">
              <i class="fas fa-inbox"></i>
              <p>Aucune composition disponible pour cette gamme.</p>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
